// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Zcyqs","mainLoginForm":"Login_mainLoginForm__C6DzN"};